import { render, staticRenderFns } from "./game-daily.vue?vue&type=template&id=3aacacfe"
import script from "./game-daily.vue?vue&type=script&lang=js"
export * from "./game-daily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aacacfe')) {
      api.createRecord('3aacacfe', component.options)
    } else {
      api.reload('3aacacfe', component.options)
    }
    module.hot.accept("./game-daily.vue?vue&type=template&id=3aacacfe", function () {
      api.rerender('3aacacfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/report/game-daily.vue"
export default component.exports